export default "__VITE_ASSET__Bb0Di$RK__"